import { useState } from "react"
import { Link } from "react-router-dom";
import { LuArrowRight, LuMapPin, LuNavigation, LuUsers } from "react-icons/lu";
import "../../styles/infoscription/infoscription.css"


const TRAINING_PLACES = [
	{
		name: "Gymnase Chantaco",
		picture: "/images/gymnase_chantaco.jpeg",
		address: "3 rue Rodolphe Cailloux",
		zip: "64500",
		city: "Saint-Jean-de-Luz",
	},
	{
		name: "Gymnase Urdazuri",
		picture: "/images/gymnase_urdazuri.jpeg",
		address: "1 Av. du Prof. Gregorio Marañon",
		zip: "64500",
		city: "Saint-Jean-de-Luz",
	},
];

//HORAIRES D'ENTRAÎNEMENT PAR CATÉGORIE
//Pour afficher / masquer une catégorie, passer "visible" à true / false
//Une case vide dans "slots" (null) = pas d'entraînement ce jour-là
const SCHEDULES = [
	{
		id: "proxy",
		label: "Jeunes (Proxy)",
		visible: true,
		days: [
			{ day: "Mardi", trainers: ["E. Brouette", "C. Durand"] },
			{ day: "Vendredi", trainers: ["M. Etcheberrigaray", "T. Iparraguire", "K. Fonseca"] },
			{ day: "Samedi", trainers: ["E. Brouette", "C. Durand"] },
		],
		certifiedTrainers: true,
		teams: [
			{
				name: "M11 - M13",
				ages: "9 à 12 ans",
				slots: [
					{ hours: "17h30 - 19h00", place: "Urdazuri" },
					null,
					{ hours: "9h00 - 10h30", place: "Chantaco" },
				],
			},
			{
				name: "M15 - M18",
				ages: "13 à 17 ans",
				slots: [
					{ hours: "18h30 - 20h00", place: "Urdazuri" },
					{ hours: "20h00 - 22h00", place: "Urdazuri" },
					{ hours: "10h00 - 12h00", place: "Chantaco" },
				],
			},
		],
	},
	{
		id: "regionale",
		label: "Régionales",
		visible: false,
		days: [
			{ day: "Mardi", trainers: ["E. Brouette"] },
			{ day: "Vendredi", trainers: ["F. Milhau", "F. Mounos", "Mikel", "M. Conan"] },
		],
		teams: [
			{
				name: "R2F",
				slots: [
					{ hours: "17h30 - 19h45", place: "Urdazuri" },
					{ hours: "20h00 - 22h00", place: "Urdazuri" },
				],
			},
			{
				name: "R2M",
				slots: [
					{ hours: "17h30 - 19h45", place: "Urdazuri" },
					{ hours: "20h00 - 22h00", place: "Urdazuri" },
				],
			},
		],
	},
	{
		id: "blvb",
		label: "Seniors loisir (BLVB)",
		visible: true,
		days: [
			{ day: "Mardi", trainers: ["Entraînement libre"] },
			{ day: "Mercredi", trainers: ["Entraînement libre"] },
		],
		teams: [
			{
				name: "Équipes seniors loisir",
				slots: [
					{ hours: "20h00 - 22h00", place: "Urdazuri" },
					{ hours: "19h30 - 23h00", place: "Chantaco" },
				],
			},
		],
	},
];

const VISIBLE_SCHEDULES = SCHEDULES.filter((schedule) => schedule.visible);

const getMapLink = (place) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${place.address}, ${place.zip} ${place.city}`)}`;


function Infoscription() {

	const [selectedScheduleId, setSelectedScheduleId] = useState(VISIBLE_SCHEDULES[0].id);
	const schedule = VISIBLE_SCHEDULES.find((s) => s.id === selectedScheduleId);

	//NAVIGATION AU CLAVIER ENTRE LES ONGLETS (flèches gauche / droite)
	const onTabKeyDown = (event, index) => {
		if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
		const step = event.key === "ArrowRight" ? 1 : -1;
		const nextIndex = (index + step + VISIBLE_SCHEDULES.length) % VISIBLE_SCHEDULES.length;
		setSelectedScheduleId(VISIBLE_SCHEDULES[nextIndex].id);
		document.getElementById(`tab-${VISIBLE_SCHEDULES[nextIndex].id}`)?.focus();
	};

	return (
		<main className="infos">

			{/* EN-TÊTE */}
			<header className="page-hero">
				<div className="wrap page-hero_content">
					<p className="page-hero_eyebrow">
						<span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
						Informations
					</p>
					<h1 className="page-hero_title">Entraînements &amp; inscriptions</h1>
					<p className="page-hero_text">Où et quand s’entraîner avec le VBLC, et comment rejoindre le club cette saison.</p>
				</div>
			</header>

			{/* INSCRIPTIONS EN LIGNE */}
			<div className="wrap">
				<div className="registration_card surface">
					<span className="icon-tile icon-tile--green" aria-hidden="true"><LuUsers /></span>
					<div className="registration_card_text">
						<span className="badge badge--success">Nouveau</span>
						<p className="registration_card_title">Les inscriptions se font désormais en ligne</p>
						<p>Licence, tarifs et certificat médical : toutes les étapes au même endroit.</p>
					</div>
					<Link to="/registration" className="btn btn--primary btn--lg registration_card_button">
						Informations et inscription <LuArrowRight aria-hidden="true" />
					</Link>
				</div>
			</div>

			{/* HORAIRES */}
			<section className="section" aria-labelledby="schedule-title">
				<div className="wrap">
					<div className="section_header">
						<div className="section_heading">
							<p className="eyebrow">Saison en cours</p>
							<h2 id="schedule-title" className="title-xl">Horaires d’entraînement</h2>
						</div>
					</div>

					<div className="schedule_tabs" role="tablist" aria-label="Catégories d’équipes">
						{VISIBLE_SCHEDULES.map((s, index) => (
							<button
								key={s.id}
								id={`tab-${s.id}`}
								role="tab"
								aria-selected={s.id === selectedScheduleId}
								aria-controls={`panel-${s.id}`}
								tabIndex={s.id === selectedScheduleId ? 0 : -1}
								className="schedule_tab"
								onClick={() => setSelectedScheduleId(s.id)}
								onKeyDown={(event) => onTabKeyDown(event, index)}
							>
								{s.label}
							</button>
						))}
					</div>

					<div id={`panel-${schedule.id}`} role="tabpanel" aria-labelledby={`tab-${schedule.id}`} className="schedule_panel surface">
						<table className="schedule_table">
							<thead>
								<tr>
									<th scope="col">Équipe</th>
									{schedule.days.map((d) => (
										<th scope="col" key={d.day}>
											<span className="schedule_day">{d.day}</span>
											<span className="schedule_trainers">{d.trainers.join(", ")}</span>
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{schedule.teams.map((team) => (
									<tr key={team.name}>
										<th scope="row">
											<span className="schedule_team">{team.name}</span>
											{team.ages && <span className="schedule_ages">{team.ages}</span>}
										</th>
										{team.slots.map((slot, index) => (
											<td key={schedule.days[index].day} data-label={schedule.days[index].day} className={slot ? "" : "is-empty"}>
												{slot
													? <>
														<span className="schedule_hours">{slot.hours}</span>
														<span className="schedule_place"><LuMapPin aria-hidden="true" />{slot.place}</span>
													</>
													: <span className="schedule_none" aria-label="Pas d’entraînement">—</span>}
											</td>
										))}
									</tr>
								))}
							</tbody>
						</table>

						{/* Sur mobile, l'en-tête du tableau est masqué : on liste l'encadrement ici */}
						<ul className="schedule_trainers_mobile">
							{schedule.days.map((d) => (
								<li key={d.day}><strong>{d.day} :</strong> {d.trainers.join(", ")}</li>
							))}
						</ul>

						{schedule.certifiedTrainers && (
							<p className="schedule_note">Encadrement assuré par des entraîneurs diplômés, sinon par des bénévoles du club.</p>
						)}
					</div>
				</div>
			</section>

			{/* LIEUX D'ENTRAÎNEMENT */}
			<section className="section section--white" aria-labelledby="places-title">
				<div className="wrap">
					<div className="section_header">
						<div className="section_heading">
							<p className="eyebrow">Où nous trouver</p>
							<h2 id="places-title" className="title-xl">Centres d’entraînement</h2>
						</div>
					</div>

					<ul className="places_grid">
						{TRAINING_PLACES.map((place) => (
							<li key={place.name} className="place_card">
								<img className="place_card_img" src={place.picture} alt={`Façade du ${place.name}`} />
								<div className="place_card_body">
									<h3 className="title-md">{place.name}</h3>
									<address className="place_card_address">{place.address}<br />{place.zip} {place.city}</address>
									<a className="link-arrow" href={getMapLink(place)} target="_blank" rel="noreferrer">
										<LuNavigation aria-hidden="true" /> Itinéraire
										<span className="sr-only">vers le {place.name} (nouvel onglet)</span>
									</a>
								</div>
							</li>
						))}
					</ul>
				</div>
			</section>
		</main>
	)
};

export default Infoscription;
